import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    country: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d4gp3bltnoqs9bvm9lq0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', country: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section className="bg-gradient-to-r from-[#003D82] to-[#0052AD] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-bold mb-6">Contactez-nous</h1>
          <div className="w-24 h-1 bg-[#FF6B35] mb-6"></div>
          <p className="text-xl max-w-4xl leading-relaxed text-white/90">
            Notre équipe est à votre écoute pour répondre à toutes vos questions et vous accompagner dans votre projet d'études à l'étranger.
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <h2 className="text-3xl font-bold text-[#003D82] mb-8">Nos coordonnées</h2>

              <div className="space-y-6">
                <div className="flex items-start bg-gray-50 rounded-xl p-6 hover:bg-[#FF6B35]/5 transition-all">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35] rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-map-pin-fill text-2xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-[#003D82] mb-1">Adresse</h3>
                    <p className="text-gray-700">Lomé Hedzranawoe, ancien OTR<br />Lomé, Togo</p>
                  </div>
                </div>

                <div className="flex items-start bg-gray-50 rounded-xl p-6 hover:bg-[#FF6B35]/5 transition-all">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35] rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-mail-fill text-2xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-[#003D82] mb-1">Email</h3>
                    <a href="mailto:eduglobecampus@gmail.com" className="text-gray-700 hover:text-[#FF6B35] transition-colors cursor-pointer">
                      eduglobecampus@gmail.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start bg-gray-50 rounded-xl p-6 hover:bg-[#FF6B35]/5 transition-all">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35] rounded-lg mr-4 flex-shrink-0">
                    <i className="ri-whatsapp-fill text-2xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-[#003D82] mb-1">WhatsApp</h3>
                    <a href="https://wa.me/22892620409" className="text-gray-700 hover:text-[#FF6B35] transition-colors cursor-pointer">
                      +228 92 62 04 09
                    </a>
                  </div>
                </div>
              </div>

              <div className="mt-8">
                <h3 className="font-bold text-[#003D82] mb-4 text-xl">Suivez-nous sur les réseaux sociaux</h3>
                <div className="flex space-x-4">
                  <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-[#FF6B35] rounded-full hover:bg-[#003D82] transition-colors cursor-pointer">
                    <i className="ri-facebook-fill text-2xl text-white"></i>
                  </a>
                  <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-[#FF6B35] rounded-full hover:bg-[#003D82] transition-colors cursor-pointer">
                    <i className="ri-instagram-fill text-2xl text-white"></i>
                  </a>
                  <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-[#FF6B35] rounded-full hover:bg-[#003D82] transition-colors cursor-pointer">
                    <i className="ri-twitter-x-fill text-2xl text-white"></i>
                  </a>
                  <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-[#FF6B35] rounded-full hover:bg-[#003D82] transition-colors cursor-pointer">
                    <i className="ri-linkedin-fill text-2xl text-white"></i>
                  </a>
                  <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-[#FF6B35] rounded-full hover:bg-[#003D82] transition-colors cursor-pointer">
                    <i className="ri-tiktok-fill text-2xl text-white"></i>
                  </a>
                </div>
              </div>

              <div className="mt-8 bg-[#FF6B35]/10 rounded-xl p-6 border-2 border-[#FF6B35]/20">
                <h3 className="font-bold text-[#003D82] mb-3 flex items-center">
                  <i className="ri-customer-service-2-fill text-2xl text-[#FF6B35] mr-2"></i>
                  Besoin d'une réponse rapide ?
                </h3>
                <p className="text-gray-700 mb-4">
                  Utilisez notre assistant virtuel pour obtenir des réponses instantanées à vos questions ou prendre rendez-vous.
                </p>
                <button
                  onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
                  className="bg-[#FF6B35] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#FF6B35]/90 transition-all whitespace-nowrap cursor-pointer inline-flex items-center"
                >
                  <i className="ri-chat-3-fill mr-2"></i>
                  Discuter maintenant
                </button>
              </div>
            </div>

            <div>
              <div className="bg-gray-50 rounded-2xl p-8">
                <h2 className="text-3xl font-bold text-[#003D82] mb-6">Envoyez-nous un message</h2>

                <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
                  <div>
                    <label htmlFor="name" className="block text-sm font-semibold text-[#003D82] mb-2">
                      Nom complet *
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#FF6B35] focus:outline-none transition-colors text-sm"
                      placeholder="Votre nom complet"
                    />
                  </div>

                  <div>
                    <label htmlFor="email" className="block text-sm font-semibold text-[#003D82] mb-2">
                      Email *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#FF6B35] focus:outline-none transition-colors text-sm"
                      placeholder="votre.email@exemple.com"
                    />
                  </div>

                  <div>
                    <label htmlFor="phone" className="block text-sm font-semibold text-[#003D82] mb-2">
                      Téléphone *
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#FF6B35] focus:outline-none transition-colors text-sm"
                      placeholder="+228 XX XX XX XX"
                    />
                  </div>

                  <div>
                    <label htmlFor="country" className="block text-sm font-semibold text-[#003D82] mb-2">
                      Pays souhaité *
                    </label>
                    <div className="relative">
                      <select
                        id="country"
                        name="country"
                        value={formData.country}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 pr-8 border-2 border-gray-200 rounded-lg focus:border-[#FF6B35] focus:outline-none transition-colors appearance-none cursor-pointer text-sm bg-white"
                      >
                        <option value="">Sélectionnez un pays</option>
                        <option value="France">France</option>
                        <option value="Canada">Canada</option>
                        <option value="Belgique">Belgique</option>
                        <option value="Autre">Autre destination</option>
                      </select>
                      <i className="ri-arrow-down-s-line absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                    </div>
                  </div>

                  <div>
                    <label htmlFor="message" className="block text-sm font-semibold text-[#003D82] mb-2">
                      Message *
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      maxLength={500}
                      rows={5}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#FF6B35] focus:outline-none transition-colors resize-none text-sm"
                      placeholder="Décrivez votre projet d'études à l'étranger..."
                    ></textarea>
                    <div className="text-right text-xs text-gray-500 mt-1">
                      {formData.message.length}/500 caractères
                    </div>
                  </div>

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full bg-[#FF6B35] text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[#FF6B35]/90 transition-all shadow-lg disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                  >
                    {isSubmitting ? (
                      <span className="flex items-center justify-center">
                        <i className="ri-loader-4-line animate-spin mr-2"></i>
                        Envoi en cours...
                      </span>
                    ) : (
                      <span className="flex items-center justify-center">
                        <i className="ri-send-plane-fill mr-2"></i>
                        Envoyer le message
                      </span>
                    )}
                  </button>

                  {submitStatus === 'success' && (
                    <div className="bg-green-50 border-2 border-green-200 rounded-lg p-4 flex items-center text-green-700">
                      <i className="ri-checkbox-circle-fill text-2xl mr-3"></i>
                      <span>Message envoyé avec succès ! Nous vous répondrons dans les plus brefs délais.</span>
                    </div>
                  )}

                  {submitStatus === 'error' && (
                    <div className="bg-red-50 border-2 border-red-200 rounded-lg p-4 flex items-center text-red-700">
                      <i className="ri-error-warning-fill text-2xl mr-3"></i>
                      <span>Une erreur s'est produite. Veuillez réessayer.</span>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-0 bg-white">
        <div className="w-full h-[500px]">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3967.0899999999997!2d1.2!3d6.13!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNsKwMDcnNDguMCJOIDHCsDEyJzAwLjAiRQ!5e0!3m2!1sfr!2stg!4v1234567890"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Localisation EduGlobe Campus - Lomé, Togo"
          ></iframe>
        </div>
      </section>

      <Footer />
    </div>
  );
}
